import Colors from "assets/Colors";
import PieChartCustom from "components/common/PieChart";
import AlertIcon from "components/icons/AlertIcon";
import Loading from "components/common/loading";
import { useTranslation } from "react-i18next";
import s from "./styles";
import { useBusinessContext } from "../../../BusinessApp";

function MoneyLine({ color, text, total = 0, last }) {
  const { currencyFormat } = useBusinessContext();
  return (
    <s.MoneyLine last={last}>
      <s.ContainerColorPaymentType>
        <s.RoundColor style={{ background: color }} />
        <s.PaymentTypeText>{text}</s.PaymentTypeText>
      </s.ContainerColorPaymentType>
      <s.Money>{currencyFormat(total)}</s.Money>
    </s.MoneyLine>
  );
}

function PieChartCategory({
  orderItemCategorySummary,
  loadingCategories,
  firstGraph,
}) {
  const { t } = useTranslation();
  const data = [];
  orderItemCategorySummary.forEach((item, index) => {
    if (index > 2) return;
    data.push({
      name: item._id?.itemName || item.name,
      value: item.total,
      color: index === 0 ? Colors.text_on_primary : Colors.text_primary,
      background:
        index === 0
          ? `${Colors.primary_web}`
          : index === 1
          ? `${Colors.primary_web_color1}80`
          : `${Colors.primary_web_color1}40`,
    });
  });

  const other = orderItemCategorySummary.reduce(
    (acc, item, index) => (index > 2 ? acc + parseFloat(item.total) : acc),
    0
  );

  data.push({
    name: "Otros",
    value: other,
    color: Colors.text_primary,
    background: `${Colors.primary_web_color1}15`,
  });

  return (
    <s.Container ref={firstGraph}>
      <s.Title>
        {t("components.ReportsItems.PieChartCategory.bestSellingItems")}
      </s.Title>
      {!loadingCategories ? (
        <>
          {orderItemCategorySummary.length > 0 ? (
            <s.BodyContainer>
              <s.body>
                <s.LeftBodyContainer>
                  {orderItemCategorySummary.map((item, index) => {
                    if (index > 2) return null;
                    return (
                      <MoneyLine
                        key={index}
                        color={
                          index === 0
                            ? `${Colors.primary_web}`
                            : index === 1
                            ? `${Colors.primary_web_color1}80`
                            : `${Colors.primary_web_color1}40`
                        }
                        // text={item?.name}
                        text={item._id?.itemName || item.name}
                        total={item.total}
                      />
                    );
                  })}
                  <MoneyLine
                    color={`${Colors.primary_web_color1}15`}
                    text="Otros"
                    total={other}
                  />
                </s.LeftBodyContainer>
              </s.body>
              <s.pieChartContainer>
                <div>
                  <PieChartCustom data={data} />
                </div>
              </s.pieChartContainer>
            </s.BodyContainer>
          ) : (
            <s.NoItemsContainer>
              <s.NoItemsMessageCenter>
                <AlertIcon style={{ display: "block", marginBottom: "7px" }} />

                {t("general.noData")}
              </s.NoItemsMessageCenter>
            </s.NoItemsContainer>
          )}
        </>
      ) : (
        <Loading height="260px" size="middle" />
      )}
    </s.Container>
  );
}

export default PieChartCategory;
